
export const FIELDS = {

  ID: 'id',
  ACCOUNT_ID: 'accountId',
  ACCOUNT_TYPE_ID: 'accountTypeId',
  ACCOUNT_TYPE: 'accountType',
  ACCOUNT_CLASS_ID: 'accountClassId',
  ACCOUNT_CLASS: 'accountClass',
  ACCOUNT_NUMBER: 'accountNumber',
  LEGAL_NAME: 'legalName',
  NAME: 'name',
  ALIAS_NAME: 'aliasName',
  WEBSITE: 'webSite',
  DESCRIPTION: 'description',
  RECENT_NOTE: 'recentNote',
  DIVISION: 'division',
  ACCOUNT_IMAGE_URL: 'accountImageUrl',
  PHONE1: 'phone1',
  PHONE2: 'phone2',
  PHONE3: 'phone3',
  FAX1: 'fax1',
  FAX2: 'fax2',
  FAX3: 'fax3',
  EMAIL1: 'email1',
  EMAIL2: 'email2',
  // ACCOUNT_CLASS_ID: 'accountClassId',
  ACCOUNT_CLASS_NAME: 'accountClassName',
  VENDOR_TYPE_ID: 'vendorTypeId',
  VENDOR_TYPE_NAME: 'vendorTypeName',
  SALES_PERSON1_USER_ID: 'salesPerson1UserId',
  SALES_PERSON2_USER_ID: 'salesPerson2UserId',
  BUYER1_USER_ID: 'buyer1UserId',
  BUYER2_USER_ID: 'buyer2UserId',
  PRIMARY_CONTACT_ID: 'primaryContactId',
  BILLING_CONTACT_ID: 'billingContactId',
  MAILING_ADDRESS_ID: 'mailingAddressId',
  SHIPPING_ADDRESS_ID: 'shippingAddressId',
  BILLING_ADDRESS_ID: 'billingAddressId',
  BILLING_TERMS_ID: 'billingTermsId',
  CREDIT_LIMIT: 'creditLimit',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  VENDOR_TERM_ID: 'vendorTermId',
  VENDOR_CREDIT_LIMIT: 'vendorCreditLimit',
  VENDOR_CURRENCY_TYPE_ID: 'vendorCurrencyTypeId',
  SCOPE: 'scope',
  REFERRAL_SOURCE: 'referralSource',
  TIMEZONE_ID: 'timezoneId',
  TIMEZONE: 'timezone',
  COMPANY_SIZE: 'companySize',
  REVENUE: 'revenue',
  TRADE_ENTITY: 'tradeEntity',
  RESELLER_ID: 'resellerId',
  DUN_AND_BRADSTREET: 'dunAndBradstreet',
  TAX_ID: 'taxId',
  VATNUMBER: 'vatNumber',
  COMMENTS: 'comments',
  BANK_NAME: 'bankName',
  BANK_CONTACT: 'bankContact',
  BANK_ACCOUNT_NUMBER: 'bankAccountNumber',
  BANK_ADDRESS: 'bankAddress',
  BANK_CITY: 'bankCity',
  BANK_STATE: 'bankState',
  BANK_POSTAL_CODE: 'bankPostalCode',
  BANK_COUNTRY: 'bankCountry',
  BANK_PHONE: 'bankPhone',
  BANK_FAX: 'bankFax',
  COUNTRY: 'country',
  DO_NOT_CALL: 'doNotCall',
  DO_NOT_EMAIL: 'doNotEmail',
  DATE_LAST_ACCESSED: 'dateLastAccessed',
  LAST_ACCESSED_BY: 'lastAccessedBy',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREDIT_HOLD: 'creditHold',
  IS_PUBLIC: 'isPublic',
  NOTES: 'notes',
  OVERALL_RATING: 'overallRating',
  ACTIVE: 'active',
  STATUS: 'status',
  SALES_PERSON1_FULL_NAME: 'salesPerson1FullName',
  SALES_PERSON2_FULL_NAME: 'salesPerson2FullName',
  BUYER1_USER_FULL_NAME: 'buyer1UserFullName',
  BUYER2_USER_FULL_NAME: 'buyer2UserFullName',
  SHIPPING_ADDRESS1: 'shippingAddress1',
  SHIPPING_ADDRESS2: 'shippingAddress2',
  SHIPPING_ADDRESS3: 'shippingAddress3',
  SHIPPING_CITY: 'shippingCity',
  SHIPPING_STATE: 'shippingState',
  SHIPPING_ZIP_CODE: 'shippingZipCode',
  SHIPPING_COUNTRY_CODE: 'shippingCountryCode',
  SHIPPING_PHONE: 'shippingPhone',
  SHIPPING_CONTACT_NAME: 'shippingContactName',
  BILLING_ADDRESS1: 'billingAddress1',
  BILLING_ADDRESS2: 'billingAddress2',
  BILLING_ADDRESS3: 'billingAddress3',
  BILLING_CITY: 'billingCity',
  BILLING_STATE: 'billingState',
  BILLING_ZIP_CODE: 'billingZipCode',
  BILLING_COUNTRY_CODE: 'billingCountryCode',
  BILLING_PHONE: 'billingPhone',
  BILLING_CONTACT_NAME: 'billingContactName',
  BILLING_TERMS_NAME: 'billingTermsName',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  VENDOR_BILLING_TERMS_NAME: 'vendorBillingTermsName',
  VENDOR_CURRENCY_TYPE_NAME: 'vendorCurrencyTypeName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  CLASS: 'class',
  // LAST_ACCESSED_BY: 'lastAccessedBy',
  // DATE_LAST_ACCESSED: 'dateLastAccessed',
  VISIBILITY: 'visibility',
  DUN_AND_BRADSTREET: 'dunAndBradstreet',
  SICCODE: 'sicCode',
  NAICSCODE: 'naicsCode',
};